export default {
  onLinkClick(sectionId) {
    // Scroll behaviour and the offset for the sticky header come from CSS
    // (scroll-behavior / scroll-padding-top in global.scss).
    document.querySelector(sectionId).scrollIntoView({ block: "start" });
  },
};
